var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative progress text-center",style:('border-color:' +
    _vm.complementaryColor +
    ';background-color:' +
    _vm.complementaryColor +
    ';')},[_c('div',{staticClass:"progress-filled position-absolute h-100",staticStyle:{"top":"0px","right":"0px"},style:('width:' + (100 - _vm.percent).toFixed(0) + '%;')}),_c('p',{staticClass:"font-size-4 font-bold line-height-xs centered-axis-xy",style:('color:' + _vm.complementaryColor + ';')},[_vm._v(" "+_vm._s(_vm.percent.toFixed(0))+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }